import { useModulesGetModuleByModuleIdQuery } from '@app/services/auto-generated/modules'
import { Language } from '@types'

const useLanguages = () => {
  const { data, isLoading, isSuccess } = useModulesGetModuleByModuleIdQuery({
    moduleId: 'Languages',
  })

  const languages: Language[] = data ? data.config.languages : []

  const getLanguageFromCode = (languageCode: string) => {
    const target = languages.find((lng) => lng.code === languageCode)
    return target
  }

  const enhanceLanguages = (languages) => {
    if (!isSuccess) {
      return []
    }
    return languages.map((lang) =>
      getLanguageFromCode(
        typeof lang === 'string' ? lang : lang.language ?? lang.code ?? lang.language_code,
      ),
    )
  }

  return { languages, isLoading, getLanguageFromCode, enhanceLanguages }
}

export default useLanguages
